(function () {
  window.theme = window.theme || {};

  theme.off_canvas = theme.off_canvas || {
    state: 'closed',
    toggleView: function () {},
    toggle: function () {},
    openRight: function () {
      this.state = 'open';
    }
  };

  theme.cart = theme.cart || {
    updateTotals: function () {
      if (window.mirailabUpdateCartBadge) {
        return fetch('/cart.js')
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            window.mirailabUpdateCartBadge(cart);
          })
          .catch(function () {});
      }
    },
    updateAllHtml: function () {
      return window.mirailabAfterCartAdd ? window.mirailabAfterCartAdd() : Promise.resolve();
    },
    addItem: async function (form) {
      var formData = new FormData(form);
      formData.append('sections', window.mirailabCartDrawerSections || 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);
      var response = await fetch(theme.urls.cart_add + '.js', {
        method: 'POST',
        body: formData
      });
      var data = await response.json();
      if (!response.ok) return false;
      if (window.mirailabAfterCartAdd) {
        await window.mirailabAfterCartAdd(data);
      }
      return true;
    }
  };
})();
